import React from "react";
import { shape, string, bool, number } from "prop-types";
import { Card, CardContent, Menu, MenuItem, Typography } from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { connectToState } from "../redux/connect-api";
import { useNavigate } from "react-router";
import { StyledHeaderLink, headerMenuStyles } from "shared/theme/styles";
import googleAnalytics from "shared/analytics";

const ITEM_HEIGHT = 48;

export const UserProfile = ({ profileData = null }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const {
    email,
    first_name, // not required in Rails model
    last_name, // not required in Rails model
    // phone_number,
  } = profileData;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    googleAnalytics.trackHeaderNav({ action: "menu", label: "Profile" });
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const navigate = useNavigate();
  const handleMenuItemClick = (e) => {
    const href = e.target.attributes["data-href"].value;
    navigate(href);
    setAnchorEl(null);
  };
  const handleLogout = () => {
    googleAnalytics.trackAuthentication(false);

    document.location.href = "/app_logout";
  };

  return (
    <>
      <StyledHeaderLink
        anchorEl={anchorEl}
        onClick={handleClick}
        aria-label="User Menu"
        aria-controls="user-profile-menu"
        aria-haspopup="true"
      >
        <AccountCircleIcon />
        <Typography component="span">Profile</Typography>
      </StyledHeaderLink>
      <Menu
        id="user-profile-menu"
        sx={headerMenuStyles}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        keepMounted
        open={open}
        onClose={handleClose}
        slotProps={{
          paper: {
            style: {
              maxHeight: ITEM_HEIGHT * 4.5,
              width: 200,
            },
          },
        }}
      >
        <Card
          elevation={0}
          sx={{ borderBottom: "1px solid #CCCCCC", borderRadius: 0, marginBottom: "10px" }}
        >
          <CardContent sx={{ paddingBottom: "15px", paddingTop: "10px" }}>
            <Typography variant="body2" noWrap>
              {first_name} {last_name}
            </Typography>
            <Typography variant="body2" noWrap>
              {email}
            </Typography>
          </CardContent>
        </Card>
        <MenuItem
          onClick={handleMenuItemClick}
          data-href="/account"
          sx={{ color: "secondary.main" }}
        >
          Account Settings
        </MenuItem>
        <MenuItem
          onClick={handleMenuItemClick}
          data-href="/password"
          sx={{ color: "secondary.main" }}
        >
          Change Password
        </MenuItem>
        <MenuItem onClick={handleLogout} sx={{ color: "secondary.main" }}>
          Log Out
        </MenuItem>
      </Menu>
    </>
  );
};

UserProfile.propTypes = {
  profileData: shape({
    email: string,
    first_name: string,
    last_name: string,
    phone_number: string,
    ec_access: bool,
    im_access: bool,
    // Allowlisted server-side; see UserSerializer.
    organization: shape({
      id: number,
      name: string,
      ec_subscription: string,
      users_can_save_price: bool,
    }),
  }),
};

const mapStateToProps = (state) => ({
  profileData: state.userProfile.data,
});

export default connectToState(mapStateToProps)(UserProfile);
